import BATLogoWhite from "@assets/img/bat-logo-white.svg?react";
import "./generic.scss";

export default function MaintenancePage() {
  return (
    <div className="maintenance-page">
      <title>Wartungsarbeiten</title>
      <BATLogoWhite className="maintenance-page-logo" />
      <div className="maintenance-page-loader" />
      <h1>Wartungsarbeiten</h1>
      <p>Die Seite ist in Kürze wieder verfügbar.</p>
      <p className="muted">Wir bitten um etwas Geduld.</p>
    </div>
  );
}
